import { ApolloClient, InMemoryCache } from '@apollo/client'
import { WebSocketLink } from '@apollo/client/link/ws'

const headers = {
  'x-hasura-admin-secret': 'instagram-clone-1500-safe'
}

const client = new ApolloClient({
  link: new WebSocketLink({
    uri: 'wss://instagram-clone-1500.herokuapp.com/v1/graphql',
    options: {
      reconnect: true,
      connectionParams: {
        headers
      }
    }
  }),
  cache: new InMemoryCache()
})

export default client
